export const HEADER_STRINGS = {
	BACK_ALT: 'Voltar',
	PHONE_TITLE: 'Telefone',
	SEE_PHONE: 'Ver telefone',
	LOADING_PHONE_ALT: 'carregando telefone',
	BLOCKED_LABEL: 'Usuário bloqueado',
	EMAIL_TITLE: 'Email',
	OPTIONS_MENU_ARIA: 'Menu de opções',
	UNBLOCK_USER: 'Desbloquear usuário',
	BLOCK_USER: 'Bloquear mensagens desse usuário',
	UNBLOCK_MODAL_TITLE: 'Desbloquear usuário',
	BLOCK_MODAL_TITLE: 'Tem certeza que deseja bloquear as mensagens desse usuário?',
	UNBLOCK_MODAL_CONTENT: 'Deseja desbloquear este usuário?',
	BLOCK_MODAL_CONTENT: 'Ao bloquear, este usuário não poderá mais enviar mensagens para você. O bloqueio pode ser desfeito a qualquer momento.',
	CANCEL: 'Cancelar',
	LOADING: 'Aguarde...',
	CONFIRM: 'Confirmar',
	CONFIRM_BLOCK: 'Sim, quero bloquear',
} as const;
